
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "2024-revision"
    }}>{`2024 revision`}</h1>
    <p>{`Partners have four development phases to complete:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}><p parentName="th"><strong parentName="p">{`#`}</strong></p></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><p parentName="th"><strong parentName="p">{`Name`}</strong></p></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><p parentName="th"><strong parentName="p">{`Applicability`}</strong></p></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><p parentName="td">{`1`}</p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td"><a parentName="p" {...{
                "href": "/guides/2024-revision/developer-dashboard"
              }}>{`Developer Dashboard`}</a></p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td">{`All partners`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><p parentName="td">{`2`}</p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td"><a parentName="p" {...{
                "href": "/guides/2024-revision/apply-with-seek"
              }}>{`Apply with SEEK`}</a></p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td">{`If your software supports `}<a parentName="p" {...{
                "href": "/use-cases/job-posting/application-methods#linking-out-to-an-external-apply-form"
              }}>{`linking out to an external apply form`}</a></p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><p parentName="td">{`3`}</p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td"><a parentName="p" {...{
                "href": "/guides/2024-revision/ad-performance"
              }}>{`Ad Performance`}</a></p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td">{`All partners`}</p></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}><p parentName="td">{`4`}</p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td"><a parentName="p" {...{
                "href": "/guides/2024-revision/hirer-identifiers"
              }}>{`Hirer identifiers`}</a></p></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><p parentName="td">{`If your software still uses legacy SEEK advertiser IDs`}</p></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;